import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { ArrowUUpLeftIcon, ArrowUUpRightIcon } from '@phosphor-icons/react'

import { Button } from '@reveni-io/reveni-ui'

import { redoShortcutLabel, undoShortcutLabel } from './constants'
import * as Styles from './styles'

const HistoryActions = ({ canUndo, onUndo, canRedo, onRedo }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Tooltip title={`${t('Deshacer')} (${undoShortcutLabel})`} arrow position="bottom">
        <Button variant="text" disabled={!canUndo} aria-label={t('Deshacer')} onClick={onUndo}>
          <ArrowUUpLeftIcon size={20} />
        </Button>
      </Tooltip>
      <Tooltip title={`${t('Rehacer')} (${redoShortcutLabel})`} arrow position="bottom">
        <Button variant="text" disabled={!canRedo} aria-label={t('Rehacer')} onClick={onRedo}>
          <ArrowUUpRightIcon size={20} />
        </Button>
      </Tooltip>
    </Styles.Container>
  )
}

export default HistoryActions
